export const CTA_INFO = {
  'Aguardando ativação': {
    label: 'Ok, entendi',
    isCloseDrawer: true,
  },
}
